import React,{useEffect} from 'react';
import Cover from "../../assets/home/cover.png"
import Logo from "../../assets/home/logo.png"
import Facebook from "../../assets/home/facebook.png"
import Instagram from "../../assets/home/instagram.png"
import ThreeWave from "../../assets/home/three_wave.png"
import Wave from "../../assets/home/wave.png"
import Cert from "../../assets/home/cert.png"
import Cert2 from "../../assets/home/cert2.png"
import Cert3 from "../../assets/home/cert3.png"
import Blur from "../../assets/home/blur.png"
import MbBlur from "../../assets/home/mbblur.png"
import Coach1 from "../../assets/home/coach1.png"
import Coach2 from "../../assets/home/coach2.png"
import Coach3 from "../../assets/home/coach3.png"
import Coach4 from "../../assets/home/coach4.png"
import Coach5 from "../../assets/home/coach5.png"
import Coach6 from "../../assets/home/coach6.png"
import Brand1 from "../../assets/home/brand1.png"
import Brand2 from "../../assets/home/brand2.png"
import Brand3 from "../../assets/home/brand3.png"
import Product1 from "../../assets/home/product1.png"
import Product2 from "../../assets/home/product2.png"
import Product3 from "../../assets/home/product3.png"
import Menu from "../../assets/home/menu.png"

import FacebookIcon from "../../assets/home/facebook-icon.png"
import InstagramIcon from "../../assets/home/instagram-icon.png"
import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import X from "../../assets/home/x.png"
import Sun from "../../assets/home/sun.png"
import BlackSun from "../../assets/home/sun-black.png"
import BlueSun from "../../assets/home/sun-blue.png"
import SunBg from "../../assets/home/sunbg.png"
import WhiteWave from "../../assets/home/wave-white.png"
// import component 👇
import Drawer from 'react-modern-drawer'
//import styles 👇
import 'react-modern-drawer/dist/index.css'
import "./home.css"
import Seo from "../../components/seo"
import { getTideData } from "../../utils/tide"
function Home() {
  const { t, i18n } = useTranslation();
  const navigation = useNavigate();
  const [isOpen, setIsOpen] = React.useState(false)
  const [isOpenSide, setIsOpenSide] = React.useState(false)
  const [isOpenSideMb, setIsOpenSideMb] = React.useState(false)
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState)
  }
  const toggleDrawerSide = () => {
    setIsOpenSide((prevState) => !prevState)
  }
  const toggleDrawerSideMb = () => {
    setIsOpenSideMb((prevState) => !prevState)
  }
  const [tideData] = React.useState(() => getTideData(new Date()))
  const [weatherData, setWeatherData] = React.useState({
    airTemp: 26,
    seaTemp: 28,
    windSpeed: 5,
    windDirection: "西北",
    waveHeight: 0.5
  })
  const getWindDirection = (degrees: number) => {
    const directions = ["北", "東北", "東", "東南", "南", "西南", "西", "西北"];
    return directions[Math.round(degrees / 45) % 8];
  }
  useEffect(() => {
    window.scrollTo(0, 0);
 }, []);
  useEffect(() => {
    const fetchSeaConditions = async () => {
      try {
        const response = await fetch(
          'https://marine-api.open-meteo.com/v1/marine?latitude=24.8607&longitude=121.8367&hourly=sea_surface_temperature,wave_height&timezone=Asia%2FTaipei&forecast_days=1'
        );
        const data = await response.json();
        const times: string[] = data.hourly.time;
        const seaTemps: number[] = data.hourly.sea_surface_temperature;
        const waveHeights: number[] = data.hourly.wave_height;
        const today = times[0].slice(0, 10);
        const currentHour = (new Date().getUTCHours() + 8) % 24;
        const hourIndex = times.indexOf(`${today}T${String(currentHour).padStart(2, '0')}:00`);
        if (hourIndex >= 0) {
          setWeatherData((prev) => ({
            ...prev,
            seaTemp: Math.round(seaTemps[hourIndex]),
            waveHeight: waveHeights[hourIndex]
          }));
        }
      } catch (error) {
        // keep fallback sea temperature/wave height
      }
    };
    const fetchWeather = async () => {
      try {
        const response = await fetch(
          'https://api.open-meteo.com/v1/forecast?latitude=24.8607&longitude=121.8367&current=temperature_2m,wind_speed_10m,wind_direction_10m&wind_speed_unit=ms&timezone=Asia%2FTaipei'
        );
        const data = await response.json();
        setWeatherData((prev) => ({
          ...prev,
          airTemp: Math.round(data.current.temperature_2m),
          windSpeed: Math.round(data.current.wind_speed_10m),
          windDirection: getWindDirection(data.current.wind_direction_10m)
        }));
      } catch (error) {
        // keep fallback air temperature/wind data
      }
    };
    fetchSeaConditions();
    fetchWeather();
  }, []);
  return (
    <div>
    <Seo title={t("seoHomeTitle")} description={t("seoHomeDescription")} path="/home" />
    <div className='home_web'>
      <button style={{display:"flex",position:"fixed",right:24,bottom:24,width:64,height:64,border:"none",backgroundColor:"white",boxShadow:"0px 4px 24px 0px rgba(12, 11, 11, 0.12)",borderRadius:16,justifyContent:"center",alignItems:"center"}} onClick={()=>{
        setIsOpenSide(true)
      }}>
      <img src={BlackSun} style={{ width: 32, height: 32 }} alt="" />

      </button>
      <div style={{ position: "fixed", display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center", paddingTop: 20 }}>
        <Link to="/home" style={{ marginLeft: 50 }}>
          <img src={Logo} style={{ width: 80, height: 80 }} alt="藍洋衝浪 Blue Ocean Surf" />
        </Link>
        <div style={{ marginRight: 50, display: "flex", alignItems: "center" }}>
          <Link to="/teach" style={{ fontWeight: "bold", fontSize: 16, marginRight: 50, fontFamily: "Noto Sans TC", color: "#0C0B0B", textDecoration: "none" }}>{t("surfTeaching")}</Link>
          <Link to="/contact" style={{ fontWeight: "bold", fontSize: 16, marginRight: 50, fontFamily: "Noto Sans TC", color: "#0C0B0B", textDecoration: "none" }}>{t("contact")}</Link>
          <a href="https://www.facebook.com/BlueOceanSurfShop/" target="_blank" rel="noopener noreferrer" style={{ marginRight: 50 }}>
            <img src={Facebook} style={{ width: 24, height: 24 }} alt="Facebook" />
          </a>
          <a href="https://www.instagram.com/blueoceansurftaiwan/" target="_blank" rel="noopener noreferrer" style={{ marginRight: 50 }}>
            <img src={Instagram} style={{ width: 24, height: 24 }} alt="Instagram" />
          </a>
          <button style={{ background: "none", border: "none", fontWeight: "bold", fontSize: 16, fontFamily: "Noto Sans TC",color:"#0C0B0B" }} onClick={() => {
            if (i18n.language === "tw") {
              i18n.changeLanguage("en")
            } else {
              i18n.changeLanguage("tw")
            }
          }}>中 / 英</button>
        </div>
      </div>
      <div style={{ backgroundImage: `url(${Cover})`, width: "100%", height: "100vh", backgroundSize: "cover", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
        <p style={{ fontWeight: "900", fontSize: 48, fontFamily: "Noto Sans TC", color: "white" }}>{t("home_first")}</p>
        <p style={{ fontWeight: "500", fontSize: 16, fontFamily: "Noto Sans TC", color: "white", width: "40%", lineHeight: "40px", textAlign: "center" }}>{t("home_second")}</p>
        <button style={{ backgroundColor: "black", width: "264px", borderRadius: "40px", border: "none", height: "56px", color: "white", fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", marginTop: 60 }}  onClick={()=>{
            window.open("https://blueoceansurf.rezio.shop/zh-TW/product/C6VDGN");
          }}>{t("home_third")}</button>
      </div>
      <div style={{ width: "100%", height: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
        <h1 style={{ fontWeight: "900", fontSize: 36, fontFamily: "Noto Sans TC" }}>{t("about_ocean")}</h1>
        <img src={ThreeWave} style={{ width: 64, height: 32, marginTop: 30 }} alt="" />
        <p style={{ fontWeight: "500", fontSize: 16, fontFamily: "Noto Sans TC", width: "50%", lineHeight: "40px", textAlign: "center", marginTop: 40 }}>{t("about_content")}</p>
        <div style={{ display: "flex", justifyContent: "space-between", width: "40%" }}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <p style={{ color: "#3697FF", fontSize: "48px", fontFamily: "Noto Sans TC", fontWeight: "600", marginBottom: 5 }}>25</p>
            <p style={{ color: "#3697FF", fontSize: "16px", fontFamily: "Noto Sans TC", fontWeight: "600" }}>{t("year")}</p>
            <p style={{ fontWeight: "700", fontSize: "20px", fontFamily: "Noto Sans TC", marginTop: 10 }}>{t("qualifications")}</p>
            <img src={Wave} style={{ width: 64, height: 8 }} alt="" />
          </div>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <p style={{ color: "#3697FF", fontSize: "48px", fontFamily: "Noto Sans TC", fontWeight: "600", marginBottom: 5 }}>ASI</p>
            <p style={{ color: "#3697FF", fontSize: "16px", fontFamily: "Noto Sans TC", fontWeight: "600" }}>{t("licence")}</p>
            <p style={{ fontWeight: "700", fontSize: "20px", fontFamily: "Noto Sans TC", marginTop: 10 }}>{t("international")}</p>
            <img src={Wave} style={{ width: 64, height: 8 }} alt="" />
          </div>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <p style={{ color: "#3697FF", fontSize: "48px", fontFamily: "Noto Sans TC", fontWeight: "600", marginBottom: 5 }}>10000+</p>
            <p style={{ color: "#3697FF", fontSize: "16px", fontFamily: "Noto Sans TC", fontWeight: "600" }}>{t("number")}</p>
            <p style={{ fontWeight: "700", fontSize: "20px", fontFamily: "Noto Sans TC", marginTop: 10 }}>{t("recommend")}</p>
            <img src={Wave} style={{ width: 64, height: 8 }} alt="" />
          </div>
        </div>
      </div>
      <div style={{ width: "100%", height: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", backgroundColor: "#F6F6F6" }}>
        <h2 style={{ fontWeight: "900", fontSize: 36, fontFamily: "Noto Sans TC" }}>{t("coach")}</h2>
        <p style={{ fontWeight: "500", fontSize: 16, fontFamily: "Noto Sans TC", width: "50%", lineHeight: "40px", textAlign: "center", marginTop: 40 }}>{t("coachContent")}</p>
        <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
          <img src={Cert} loading="lazy" style={{ width: 400, height: 280, marginRight: 32 }} alt={t("certAlt")} />
          <img src={Cert2} loading="lazy" style={{ width: 200, height: 280 }} alt={t("certAlt")} />
          <img src={Cert3} loading="lazy" style={{ width: 200, height: 280 }} alt={t("certAlt")} />
        </div>
      </div>
      <div style={{ backgroundImage: `url(${Blur})`, width: "100%", height: "520px", backgroundSize: "cover", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
        <p style={{ fontWeight: "800", fontSize: 36, fontFamily: "Noto Sans TC", color: "white" }}>{t("skill")}</p>
        <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "white", width: "70%", lineHeight: "40px", textAlign: "center" }}>{t("skillContent")}</p>
      </div>
      <div style={{ width: "100%", height: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ width: 312, boxShadow: "0px 4px 16px 0px rgba(12, 11, 11, 0.08)", borderRadius: "4px", padding: "32px 24px", display: "flex", flexDirection: "column", alignItems: "center", marginRight: 36 }}>
          <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#3697FF" }}>{t("price1Title")}</p>
          <p style={{ fontWeight: "600", fontSize: 36, fontFamily: "Noto Sans TC", color: "#0C0B0B", margin: 0 }}>NT$600</p>
          <p style={{ fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#8F8F8F", marginBottom: 35 }}>{t("perPrice")}</p>
          <img src={Wave} style={{ width: 64, height: 8, marginBottom: 30 }} alt="" />
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price1Class1")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price1Class2")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price1Class3")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price1Class4")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price1Class5")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>&nbsp;</p>
          <button style={{ width: "100%", height: "48px", border: "none", backgroundColor: "#D7EAFF", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "40px", fontWeight: "700", fontSize: 14, fontFamily: "Noto Sans TC", marginTop: 30 }}   onClick={()=>{
            window.open("https://blueoceansurf.rezio.shop/zh-TW/product/C6VDGN");
          }}>
            {t("more")}
          </button>
        </div>
        <div style={{ width: 312, boxShadow: "0px 4px 16px 0px rgba(12, 11, 11, 0.08)", borderRadius: "4px", padding: "32px 24px", display: "flex", flexDirection: "column", alignItems: "center", marginRight: 36 }}>
          <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#3697FF" }}>{t("price2Title")}</p>
          <p style={{ fontWeight: "600", fontSize: 36, fontFamily: "Noto Sans TC", color: "#0C0B0B", margin: 0 }}>NT$1700</p>
          <p style={{ fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#8F8F8F", marginBottom: 35 }}>{t("perPrice")}</p>
          <img src={Wave} style={{ width: 64, height: 8, marginBottom: 30 }} alt="" />
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price2Class1")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price2Class2")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price2Class3")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price2Class4")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price2Class5")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price2Class6")}</p>
          <button style={{ width: "100%", height: "48px", border: "none", backgroundColor: "#D7EAFF", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "40px", fontWeight: "700", fontSize: 14, fontFamily: "Noto Sans TC", marginTop: 30 }}   onClick={()=>{
            window.open("https://blueoceansurf.rezio.shop/zh-TW/product/C6VDGN");
          }}>
            {t("more")}
          </button>
        </div>
        <div style={{ width: 312, boxShadow: "0px 4px 16px 0px rgba(12, 11, 11, 0.08)", borderRadius: "4px", padding: "32px 24px", display: "flex", flexDirection: "column", alignItems: "center" }}>
          <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#3697FF" }}>{t("price3Title")}</p>
          <p style={{ fontWeight: "600", fontSize: 36, fontFamily: "Noto Sans TC", color: "#0C0B0B", margin: 0 }}>NT$1050{t("up")}</p>
          <p style={{ fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#8F8F8F", marginBottom: 35 }}>{t("perPrice")}</p>
          <img src={Wave} style={{ width: 64, height: 8, marginBottom: 30 }} alt="" />
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price3Class1")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price3Class2")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price3Class3")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price3Class4")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price3Class5")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price3Class6")}</p>
          <button style={{ width: "100%", height: "48px", border: "none", backgroundColor: "#D7EAFF", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "40px", fontWeight: "700", fontSize: 14, fontFamily: "Noto Sans TC", marginTop: 30 }}   onClick={()=>{
            window.open("https://blueoceansurf.rezio.shop/zh-TW/product/C6VDGN");
          }}>
            {t("more")}
          </button>
        </div>
      </div>
      <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", backgroundColor: "#F6F6F6" }}>
        <h2 style={{ fontWeight: "900", fontSize: 36, fontFamily: "Noto Sans TC", marginTop: 120 }}>{t("team")}</h2>
        <img src={ThreeWave} style={{ width: 64, height: 32, marginTop: 30 }} alt="" />
        <p style={{ fontWeight: "500", fontSize: 16, fontFamily: "Noto Sans TC", width: "60%", lineHeight: "40px", textAlign: "center", marginTop: 40 }}>{t("teamContent")}</p>
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 60 }}>
          <div style={{ display: "flex", flexDirection: "column", backgroundColor: "white", borderRadius: "4px", marginRight: 60 }}>
            <img src={Coach1} loading="lazy" style={{ width: 290, height: 280 }} alt={t("coach1")} />
            <p style={{ fontWeight: "700", fontSize: 20, fontFamily: "Noto Sans TC", marginLeft: "24px" }}>{t("coach1")}</p>
            <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", marginLeft: "24px", color: "#404040", marginTop: 0, marginBottom: 20 }}>{t("firstAndSecondTeach")}</p>
          </div>
          <div style={{ display: "flex", flexDirection: "column", backgroundColor: "white", borderRadius: "4px", marginRight: 60 }}>
            <img src={Coach2} loading="lazy" style={{ width: 290, height: 280 }} alt={t("coach2")} />
            <p style={{ fontWeight: "700", fontSize: 20, fontFamily: "Noto Sans TC", marginLeft: "24px" }}>{t("coach2")}</p>
            <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", marginLeft: "24px", color: "#404040", marginTop: 0, marginBottom: 20 }}>{t("firstAndSecondTeach")}</p>
          </div>
          <div style={{ display: "flex", flexDirection: "column", backgroundColor: "white", borderRadius: "4px" }}>
            <img src={Coach3} loading="lazy" style={{ width: 290, height: 280 }} alt={t("coach3")} />
            <p style={{ fontWeight: "700", fontSize: 20, fontFamily: "Noto Sans TC", marginLeft: "24px" }}>{t("coach3")}</p>
            <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", marginLeft: "24px", color: "#404040", marginTop: 0, marginBottom: 20 }}>{t("firstTeach")}</p>
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 60, marginBottom: 120 }}>
          <div style={{ display: "flex", flexDirection: "column", backgroundColor: "white", borderRadius: "4px", marginRight: 60 }}>
            <img src={Coach4} loading="lazy" style={{ width: 290, height: 280 }} alt={t("coach4")} />
            <p style={{ fontWeight: "700", fontSize: 20, fontFamily: "Noto Sans TC", marginLeft: "24px" }}>{t("coach4")}</p>
            <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", marginLeft: "24px", color: "#404040", marginTop: 0, marginBottom: 20 }}>{t("firstAndSecondTeach")}</p>
          </div>
          <div style={{ display: "flex", flexDirection: "column", backgroundColor: "white", borderRadius: "4px", marginRight: 60 }}>
            <img src={Coach5} loading="lazy" style={{ width: 290, height: 280 }} alt={t("coach5")} />
            <p style={{ fontWeight: "700", fontSize: 20, fontFamily: "Noto Sans TC", marginLeft: "24px" }}>{t("coach5")}</p>
            <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", marginLeft: "24px", color: "#404040", marginTop: 0, marginBottom: 20 }}>{t("firstAndSecondTeach")}</p>
          </div>
          <div style={{ display: "flex", flexDirection: "column", backgroundColor: "white", borderRadius: "4px" }}>
            <img src={Coach6} loading="lazy" style={{ width: 290, height: 280 }} alt={t("coach6")} />
            <p style={{ fontWeight: "700", fontSize: 20, fontFamily: "Noto Sans TC", marginLeft: "24px" }}>{t("coach6")}</p>
            <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", marginLeft: "24px", color: "#404040", marginTop: 0, marginBottom: 20 }}>{t("firstTeach")}</p>
          </div>
        </div>
      </div>
      <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
        <h2 style={{ fontWeight: "900", fontSize: 36, fontFamily: "Noto Sans TC", marginTop: 120 }}>{t("brandTitle")}</h2>
        <img src={ThreeWave} style={{ width: 64, height: 32, marginTop: 30 }} alt="" />
        <p style={{ fontWeight: "500", fontSize: 16, fontFamily: "Noto Sans TC", width: "60%", lineHeight: "40px", textAlign: "center", marginTop: 40 }}>{t("brandContent")}</p>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <img src={Brand1} loading="lazy" style={{ width: 135, height: 74 }} alt="Almond" />
          <img src={Brand2} loading="lazy" style={{ width: 176, height: 80, marginLeft: 30 }} alt="JS Industries" />
          <img src={Brand3} loading="lazy" style={{ width: 115, height: 48, marginLeft: 30 }} alt="Keyo" />
        </div>
        <button style={{ width: "264px", height: "56px", border: "none", backgroundColor: "#D7EAFF", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "40px", fontWeight: "700", fontSize: 14, fontFamily: "Noto Sans TC", marginTop: 30 }}>
          {t("shop")}
        </button>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 120, marginTop: 64 }}>
          <img src={Product1} loading="lazy" style={{ width: 488, height: 488, marginRight: 30 }} alt="Almond"   onClick={()=>{
            window.open("https://almondsurfboards.com/");
          }}/>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <img src={Product2} loading="lazy" style={{ width: 488, height: 228, marginBottom: 30 }} alt="JS Industries" onClick={()=>{
            window.open("https://jsindustries.com/");
          }}/>
            <img src={Product3} loading="lazy" style={{ width: 488, height: 228 }} alt="Keyo" onClick={()=>{
            window.open("https://www.keyointernational.com/");
          }}/>
          </div>
        </div>
      </div>
      <div style={{ width: "100%", backgroundColor: "black",paddingTop:64,paddingBottom:24 }}>
        <p style={{ fontWeight: "700", fontSize: 20, fontFamily: "Noto Sans TC", color: "white",marginLeft:112 }}>{t("blueOcean")}</p>
        <div style={{ display: "flex", alignItems: "center",marginLeft:112 }}>
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("open")}</p>
          <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>07:00 - 19:00</p>
        </div>
        <div style={{ display: "flex", alignItems: "center",marginLeft:112 }}>
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("storePhone")}</p>
          <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>+886 3 978 9233</p>
        </div>
        <div style={{ display: "flex", alignItems: "center" ,marginLeft:112}}>
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("bookingPhone")}</p>
          <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>+886 928 378 138</p>
        </div>
        <div style={{ display: "flex", alignItems: "center",marginLeft:112 }}>
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("email")}</p>
          <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>chehow_0906@hotmail.com</p>
        </div>
        <div style={{ display: "flex", alignItems: "center",marginLeft:112 }}>
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("address")}</p>
          <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>{t("addressRoad")}</p>
        </div>
        <div style={{ display: "flex", alignItems: "center", marginTop: 15,marginLeft:112 }}>
          <a href="https://www.facebook.com/BlueOceanSurfShop/" target="_blank" rel="noopener noreferrer" style={{ marginRight: 24 }}>
            <img src={FacebookIcon} style={{ width: 20, height: 20 }} alt="Facebook" />
          </a>
          <a href="https://www.instagram.com/blueoceansurftaiwan/" target="_blank" rel="noopener noreferrer">
            <img src={InstagramIcon} style={{ width: 20, height: 20 }} alt="Instagram" />
          </a>
        </div>
        <div style={{width:"85%",height:1,backgroundColor:"#404040",margin:"auto",marginTop:64}}></div>
        <p style={{ fontWeight: "600", fontSize: 12, fontFamily: "Noto Sans TC", color: "#8F8F8F",textAlign:"center",marginTop:24 }}>© 2026藍洋衝浪店Blue Ocean Surf Shop</p>
      </div>
    </div>
    <div className='home_phone'>
      <div style={{ position: "fixed", display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
        <Link to="/home">
          <img src={Logo} style={{ width: 48, height: 48,marginTop:24,marginLeft:24 }} alt="藍洋衝浪 Blue Ocean Surf" />
        </Link>
        <img src={Menu} style={{ width: 24, height: 24, marginTop:24,marginRight:24}} alt=""  onClick={() => {
            setIsOpen(true)
          }}/>        
      </div>
      <div style={{ backgroundImage: `url(${Cover})`, width: "100%", height: "800px", backgroundSize: "cover", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
        <p style={{ fontWeight: "900", fontSize: 36, fontFamily: "Noto Sans TC", color: "white",textAlign:"center" }}>{t("home_first")}</p>
        <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "white", lineHeight: "40px", textAlign: "center",width:"90%" }}>{t("home_second")}</p>
        <button style={{ backgroundColor: "black", width: "218px", borderRadius: "40px", border: "none", height: "48px", color: "white", fontWeight: "700", fontSize: 14, fontFamily: "Noto Sans TC", marginTop: 60 }} onClick={()=>{
            window.open("https://blueoceansurf.rezio.shop/zh-TW/product/C6VDGN");
          }}>{t("home_third")}</button>
      </div>
      <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column",marginTop:30,marginBottom:80 }}>
        <h1 style={{ fontWeight: "900", fontSize: 24, fontFamily: "Noto Sans TC" }}>{t("about_ocean")}</h1>
        <img src={ThreeWave} style={{ width: 64, height: 32, marginTop: 30 }} alt="" />
        <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", width: "90%", lineHeight: "40px", textAlign: "center", marginTop: 40 }}>{t("about_content")}</p>
        <div style={{ display: "flex", justifyContent: "space-between",flexDirection:"column" }}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <p style={{ color: "#3697FF", fontSize: "36px", fontFamily: "Noto Sans TC", fontWeight: "600", marginBottom: 5 }}>25</p>
            <p style={{ color: "#3697FF", fontSize: "16px", fontFamily: "Noto Sans TC", fontWeight: "600" }}>{t("year")}</p>
            <p style={{ fontWeight: "700", fontSize: "20px", fontFamily: "Noto Sans TC", marginTop: 10 }}>{t("qualifications")}</p>
            <img src={Wave} style={{ width: 64, height: 8 }} alt="" />
          </div>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <p style={{ color: "#3697FF", fontSize: "36px", fontFamily: "Noto Sans TC", fontWeight: "600", marginBottom: 5 }}>ASI</p>
            <p style={{ color: "#3697FF", fontSize: "16px", fontFamily: "Noto Sans TC", fontWeight: "600" }}>{t("licence")}</p>
            <p style={{ fontWeight: "700", fontSize: "20px", fontFamily: "Noto Sans TC", marginTop: 10 }}>{t("international")}</p>
            <img src={Wave} style={{ width: 64, height: 8 }} alt="" />
          </div>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <p style={{ color: "#3697FF", fontSize: "36px", fontFamily: "Noto Sans TC", fontWeight: "600", marginBottom: 5 }}>10000+</p>
            <p style={{ color: "#3697FF", fontSize: "16px", fontFamily: "Noto Sans TC", fontWeight: "600" }}>{t("number")}</p>
            <p style={{ fontWeight: "700", fontSize: "20px", fontFamily: "Noto Sans TC", marginTop: 10 }}>{t("recommend")}</p>
            <img src={Wave} style={{ width: 64, height: 8 }} alt="" />
          </div>
        </div>
      </div>
      <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", backgroundColor: "#F6F6F6" }}>
        <h2 style={{ fontWeight: "900", fontSize: 24, fontFamily: "Noto Sans TC",width:"75%",textAlign:"center",marginTop:80,lineHeight:"40px" }}>{t("coach")}</h2>
        <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", width: "90%", lineHeight: "40px", textAlign: "center", marginTop: 40 }}>{t("coachContent")}</p>
        <div style={{ display: "flex", justifyContent: "center", marginTop: 20,flexDirection:"column",alignItems:"center",marginBottom:80 }}>
          <img src={Cert} loading="lazy" style={{ width: "90%" }} alt={t("certAlt")} />
          <div style={{display:"flex",justifyContent:"center",marginTop:32}}>
          <img src={Cert2} loading="lazy" style={{ width: "45%" }} alt={t("certAlt")} />
          <img src={Cert3} loading="lazy" style={{ width: "45%" }} alt={t("certAlt")} />
          </div>
        </div>
      </div>
      <div style={{ backgroundImage: `url(${MbBlur})`, width: "100%", backgroundSize: "cover", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column",backgroundPosition:"center" }}>
        <p style={{ fontWeight: "800", fontSize: 24, fontFamily: "Noto Sans TC", color: "white",width:"75%",textAlign:"center",marginTop:80,lineHeight:"40px" }}>{t("skill")}</p>
        <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "white", width: "90%", lineHeight: "40px", textAlign: "center",marginBottom:80 }}>{t("skillContent")}</p>
      </div>
      <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center",flexDirection:"column" }}>
        <div style={{ width: "75%", boxShadow: "0px 4px 16px 0px rgba(12, 11, 11, 0.08)", borderRadius: "4px", padding: "32px 24px", display: "flex", flexDirection: "column", alignItems: "center",marginTop:80}}>
          <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#3697FF" }}>{t("price1Title")}</p>
          <p style={{ fontWeight: "600", fontSize: 36, fontFamily: "Noto Sans TC", color: "#0C0B0B", margin: 0 }}>NT$600</p>
          <p style={{ fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#8F8F8F", marginBottom: 35 }}>{t("perPrice")}</p>
          <img src={Wave} style={{ width: 64, height: 8, marginBottom: 30 }} alt="" />
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price1Class1")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price1Class2")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price1Class3")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price1Class4")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price1Class5")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>&nbsp;</p>
          <button style={{ width: "100%", height: "48px", border: "none", backgroundColor: "#D7EAFF", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "40px", fontWeight: "700", fontSize: 14, fontFamily: "Noto Sans TC", marginTop: 30,color:"#0C0B0B" }}   onClick={()=>{
            window.open("https://blueoceansurf.rezio.shop/zh-TW/product/C6VDGN");
          }}>
            {t("more")}
          </button>
        </div>
        <div style={{width: "75%", boxShadow: "0px 4px 16px 0px rgba(12, 11, 11, 0.08)", borderRadius: "4px", padding: "32px 24px", display: "flex", flexDirection: "column", alignItems: "center",marginTop:32 }}>
          <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#3697FF" }}>{t("price2Title")}</p>
          <p style={{ fontWeight: "600", fontSize: 36, fontFamily: "Noto Sans TC", color: "#0C0B0B", margin: 0 }}>NT$1700</p>
          <p style={{ fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#8F8F8F", marginBottom: 35 }}>{t("perPrice")}</p>
          <img src={Wave} style={{ width: 64, height: 8, marginBottom: 30 }} alt="" />
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price2Class1")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price2Class2")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price2Class3")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price2Class4")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price2Class5")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price2Class6")}</p>
          <button style={{ width: "100%", height: "48px", border: "none", backgroundColor: "#D7EAFF", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "40px", fontWeight: "700", fontSize: 14, fontFamily: "Noto Sans TC", marginTop: 30, color: "#0C0B0B" }}   onClick={()=>{
            window.open("https://blueoceansurf.rezio.shop/zh-TW/product/C6VDGN");
          }}>
            {t("more")}
          </button>
        </div>
        <div style={{ width: "75%", boxShadow: "0px 4px 16px 0px rgba(12, 11, 11, 0.08)", borderRadius: "4px", padding: "32px 24px", display: "flex", flexDirection: "column", alignItems: "center" ,marginTop:32,marginBottom:80}}>
          <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#3697FF" }}>{t("price3Title")}</p>
          <p style={{ fontWeight: "600", fontSize: 36, fontFamily: "Noto Sans TC", color: "#0C0B0B", margin: 0 }}>NT$1050{t("up")}</p>
          <p style={{ fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#8F8F8F", marginBottom: 35 }}>{t("perPrice")}</p>
          <img src={Wave} style={{ width: 64, height: 8, marginBottom: 30 }} alt="" />
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price3Class1")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price3Class2")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price3Class3")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price3Class4")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price3Class5")}</p>
          <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price3Class6")}</p>
          <button style={{ width: "100%", height: "48px", border: "none", backgroundColor: "#D7EAFF", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "40px", fontWeight: "700", fontSize: 14, fontFamily: "Noto Sans TC", marginTop: 30,color:"#0C0B0B" }}   onClick={()=>{
            window.open("https://blueoceansurf.rezio.shop/zh-TW/product/C6VDGN");
          }}>
            {t("more")}
          </button>
        </div>
      </div>
      <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", backgroundColor: "#F6F6F6" }}>
        <h2 style={{ fontWeight: "900", fontSize: 24, fontFamily: "Noto Sans TC", marginTop: 120 }}>{t("team")}</h2>
        <img src={ThreeWave} style={{ width: 64, height: 32, marginTop: 30 }} alt="" />
        <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", width: "85%", lineHeight: "40px", textAlign: "center", marginTop: 40 }}>{t("teamContent")}</p>
        <div style={{ display: "flex", justifyContent: "center", marginTop: 60,width: "100%" }}>
          <div style={{ display: "flex", flexDirection: "column", backgroundColor: "white", borderRadius: "4px", marginRight: 16,width: "40%" }}>
            <img src={Coach1} loading="lazy" style={{ width: "100%" }} alt={t("coach1")} />
            <p style={{ fontWeight: "700", fontSize: 20, fontFamily: "Noto Sans TC", marginLeft: "24px" }}>{t("coach1")}</p>
            <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", marginLeft: "24px", color: "#404040", marginTop: 0, marginBottom: 20 }}>{t("firstAndSecondTeach")}</p>
          </div>
          <div style={{ display: "flex", flexDirection: "column", backgroundColor: "white", borderRadius: "4px",width: "40%"  }}>
            <img src={Coach2} loading="lazy" style={{width: "100%"}} alt={t("coach2")} />
            <p style={{ fontWeight: "700", fontSize: 20, fontFamily: "Noto Sans TC", marginLeft: "24px" }}>{t("coach2")}</p>
            <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", marginLeft: "24px", color: "#404040", marginTop: 0, marginBottom: 20 }}>{t("firstAndSecondTeach")}</p>
          </div>
          
        </div>
        <div style={{ display: "flex", justifyContent: "center", marginTop: 30, marginBottom: 10,width: "100%" }}>
          <div style={{ display: "flex", flexDirection: "column", backgroundColor: "white", borderRadius: "4px",width: "40%",marginRight: 16  }}>
            <img src={Coach3} loading="lazy" style={{ width: "100%" }} alt={t("coach3")} />
            <p style={{ fontWeight: "700", fontSize: 20, fontFamily: "Noto Sans TC", marginLeft: "24px" }}>{t("coach3")}</p>
            <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", marginLeft: "24px", color: "#404040", marginTop: 0, marginBottom: 20 }}>{t("firstTeach")}</p>
          </div>
          <div style={{ display: "flex", flexDirection: "column", backgroundColor: "white", borderRadius: "4px",width: "40%"  }}>
            <img src={Coach4} loading="lazy" style={{ width: "100%" }} alt={t("coach4")} />
            <p style={{ fontWeight: "700", fontSize: 20, fontFamily: "Noto Sans TC", marginLeft: "24px" }}>{t("coach4")}</p>
            <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", marginLeft: "24px", color: "#404040", marginTop: 0, marginBottom: 20 }}>{t("firstTeachEng")}</p>
          </div>
          
        </div>
        <div style={{ display: "flex", justifyContent: "center", marginTop: 30, marginBottom: 120,width: "100%" }}>
          
          <div style={{ display: "flex", flexDirection: "column", backgroundColor: "white", borderRadius: "4px", marginRight: 16,width: "40%" }}>
            <img src={Coach5} loading="lazy" style={{ width: "100%" }} alt={t("coach5")} />
            <p style={{ fontWeight: "700", fontSize: 20, fontFamily: "Noto Sans TC", marginLeft: "24px" }}>{t("coach5")}</p>
            <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", marginLeft: "24px", color: "#404040", marginTop: 0, marginBottom: 20 }}>{t("firstAndSecondTeach")}</p>
          </div>
          <div style={{ display: "flex", flexDirection: "column", backgroundColor: "white", borderRadius: "4px",width: "40%" }}>
            <img src={Coach6} loading="lazy" style={{ width: "100%"}} alt={t("coach6")} />
            <p style={{ fontWeight: "700", fontSize: 20, fontFamily: "Noto Sans TC", marginLeft: "24px" }}>{t("coach6")}</p>
            <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", marginLeft: "24px", color: "#404040", marginTop: 0, marginBottom: 20 }}>{t("firstTeach")}</p>
          </div>
        </div>
      </div>
      <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
        <h2 style={{ fontWeight: "900", fontSize: 24, fontFamily: "Noto Sans TC", marginTop: 120 }}>{t("brandTitle")}</h2>
        <img src={ThreeWave} style={{ width: 64, height: 32, marginTop: 30 }} alt="" />
        <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", width: "90%", lineHeight: "40px", textAlign: "center", marginTop: 40 }}>{t("brandContent")}</p>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center",flexDirection:"column" }}>
          <img src={Brand1} loading="lazy" style={{ width: 135, height: 74 }} alt="Almond" />
          <img src={Brand2} loading="lazy" style={{ width: 176, height: 80 , marginTop:30 }} alt="JS Industries" />
          <img src={Brand3} loading="lazy" style={{ width: 115, height: 48 , marginTop:30 }} alt="Keyo" />
        </div>
        <button style={{ width: "264px", height: "56px", border: "none", backgroundColor: "#D7EAFF", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "40px", fontWeight: "700", fontSize: 14, fontFamily: "Noto Sans TC", marginTop: 30,color:"#0C0B0B" }}>
          {t("shop")}
        </button>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 120, marginTop: 64,flexDirection:"column",alignItems:"center",width:"100%" }}>
          <img src={Product1} loading="lazy" style={{ width: "80%" }} alt="Almond" />
            <img src={Product2} loading="lazy" style={{ width: "80%",marginTop:32 }} alt="JS Industries" />
            <img src={Product3} loading="lazy" style={{ width: "80%",marginTop:32 }} alt="Keyo" />
        </div>
      </div>
      <div style={{ width: "100%", backgroundColor: "black",paddingTop:64,paddingBottom:24 }}>
        <p style={{ fontWeight: "700", fontSize: 20, fontFamily: "Noto Sans TC", color: "white",marginLeft:20 }}>{t("blueOcean")}</p>
        <div style={{ display: "flex", alignItems: "center",marginLeft:24 }}>
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("open")}</p>
          <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>07:00 - 19:00</p>
        </div>
        <div style={{ display: "flex", alignItems: "center",marginLeft:24 }}>
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("storePhone")}</p>
          <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>+886 3 978 9233</p>
        </div>
        <div style={{ display: "flex", alignItems: "center" ,marginLeft:24}}>
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("bookingPhone")}</p>
          <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>+886 928 378 138</p>
        </div>
        <div style={{ display: "flex", alignItems: "center",marginLeft:24 }}>
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("email")}</p>
          <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>chehow_0906@hotmail.com</p>
        </div>
        <div style={{ display: "flex", alignItems: "center",marginLeft:24 }}>
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("address")}</p>
          <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>{t("addressRoad")}</p>
        </div>
        <div style={{ display: "flex", alignItems: "center", marginTop: 15,marginLeft:24 }}>
          <a href="https://www.facebook.com/BlueOceanSurfShop/" target="_blank" rel="noopener noreferrer" style={{ marginRight: 24 }}>
            <img src={FacebookIcon} style={{ width: 20, height: 20 }} alt="Facebook" />
          </a>
          <a href="https://www.instagram.com/blueoceansurftaiwan/" target="_blank" rel="noopener noreferrer">
            <img src={InstagramIcon} style={{ width: 20, height: 20 }} alt="Instagram" />
          </a>
        </div>
        <div style={{width:"85%",height:1,backgroundColor:"#404040",margin:"auto",marginTop:64}}></div>
        <p style={{ fontWeight: "600", fontSize: 12, fontFamily: "Noto Sans TC", color: "#8F8F8F",textAlign:"center",marginTop:24 }}>© 2026藍洋衝浪店Blue Ocean Surf Shop</p>
      </div>
    </div>
    <Drawer
        open={isOpen}
        onClose={toggleDrawer}
        direction='right'
        className='bla bla bla'
        size={"100%"}
      >
        <div style={{ backgroundColor: "#0C0B0B", height: "100vh", display: "flex",flexDirection:"column" }}>
          <div style={{ display: "flex", justifyContent: "space-between", width: "100%", height: 80, alignItems: "center" }}>
            <img src={Logo} style={{ width: 48, height: 48, marginLeft: 24 }} alt="藍洋衝浪 Blue Ocean Surf"  onClick={() => {
              navigation("/home")
              setIsOpen(false)

            }}/>
            <img src={X} style={{ width: 24, height: 24, marginRight: 24 }} alt="" onClick={() => {
              setIsOpen(false)
            }} />
          </div>
          <button style={{border:"none",backgroundColor:"transparent"}} onClick={() => {
              navigation("/teach")
              setIsOpen(false)

            }}>
            <p style={{fontWeight: "700", fontSize: 20, fontFamily: "Noto Sans TC", color: "white"}}>{t("surfTeaching")}</p>
          </button>
          <button style={{border:"none",backgroundColor:"transparent"}} onClick={() => {
              navigation("/contact")
              setIsOpen(false)

            }}>
            <p style={{fontWeight: "700", fontSize: 20, fontFamily: "Noto Sans TC", color: "white",marginTop:40}}>{t("contact")}</p>
          </button>
          <button style={{border:"none",backgroundColor:"transparent"}} onClick={() => {
                        window.open("https://www.facebook.com/BlueOceanSurfShop/");

              setIsOpen(false)
            }}>
          <img src={FacebookIcon} style={{ width: 24, height: 24,marginTop:40 }} alt="Facebook" />
          </button>
          <button style={{border:"none",backgroundColor:"transparent"}} onClick={() => {
             window.open("https://www.instagram.com/blueoceansurftaiwan/");
              setIsOpen(false)
            }}>
          <img src={InstagramIcon} style={{ width: 24, height: 24,marginTop:40 }} alt="Instagram" />
          </button>
          <button style={{border:"none",backgroundColor:"transparent"}}onClick={() => {
            if (i18n.language === "tw") {
              i18n.changeLanguage("en")
            } else {
              i18n.changeLanguage("tw")
            }
              setIsOpen(false)
            }}>
            <p style={{fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "white",marginTop:40}}>中 / ＥＮ</p>
          </button>
          <button style={{border:"none",backgroundColor:"transparent"}} onClick={() => {
              setIsOpen(false)
            }}>
          <img src={Sun} style={{ width: 24, height: 24,marginTop:40 }} alt="" onClick={()=>{
            setIsOpenSideMb(true)
          }}/>
          </button>
        </div>
      </Drawer>
      <Drawer
        open={isOpenSide}
        onClose={toggleDrawerSide}
        direction='right'
        className='bla bla bla'
        size={112}
      >
        <div style={{ height: "100vh", display: "flex",flexDirection:"column",boxShadow:"-4px 0px 16px 0px rgba(12, 11, 11, 0.12);",alignItems:"center" }}>
        <img src={BlueSun} style={{ width: 32, height: 32,marginTop:40 }} alt="" />
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.airTemp}°</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>{t("air")}</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.seaTemp}°</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>{t("sea")}</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.windSpeed}</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>{t("windSpeed")}</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.waveHeight}m</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>{t("waveHeight")}</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.windDirection}</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>{t("windDirection")}</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
            <p style={{fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{tideData.lowTides[0]}</p>
            <p style={{fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0}}>{tideData.lowTides[1]}</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>{t("lowTide")}</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
            <p style={{fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{tideData.highTides[0]}</p>
            <p style={{fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0}}>{tideData.highTides[1]}</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>{t("highTide")}</p>
            </div>
        <img src={X} style={{ width: 32, height: 32,marginTop:40 }} alt="" onClick={()=>{
          setIsOpenSide(false)
        }}/>

        </div>
      </Drawer>
      <Drawer
        open={isOpenSideMb}
        onClose={toggleDrawerSideMb}
        direction='right'
        className='bla bla bla'
        size={"100%"}
      >
        <div style={{ backgroundImage: `url(${SunBg})`, height: "100vh", display: "flex",flexDirection:"column", backgroundSize: "cover" ,alignItems:"center"}}>
          <div style={{ display: "flex", justifyContent: "space-between", width: "100%", height: 80, alignItems: "center" }}>
            <img src={Logo} style={{ width: 48, height: 48, marginLeft: 24 }} alt="藍洋衝浪 Blue Ocean Surf"  onClick={() => {
              navigation("/home")
              setIsOpenSideMb(false)

            }}/>
            <img src={X} style={{ width: 24, height: 24, marginRight: 24 }} alt="" onClick={() => {
              setIsOpenSideMb(false)
            }} />
          </div>
          <img src={BlueSun} style={{ width: 56, height: 56,marginTop:40 }} alt="" />
          <div style={{display:"flex",justifyContent:"space-between",width:"40%",marginTop:30}}>
          <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.airTemp}°</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>{t("air")}</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.seaTemp}°</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>{t("sea")}</p>
            </div>

          </div>
          <img src={WhiteWave} style={{ width: 64, height: 8,marginTop:20 }} alt="" />

          <div style={{display:"flex",justifyContent:"space-between",width:"70%"}}>
          <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.windSpeed}</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>{t("windSpeed")}</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.waveHeight}m</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>{t("waveHeight")}</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.windDirection}</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>{t("windDirection")}</p>
            </div>

          </div>
          <img src={WhiteWave} style={{ width: 64, height: 8,marginTop:20 }} alt="" />

          <div style={{display:"flex",justifyContent:"space-between",width:"40%"}}>
          <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
          <p style={{fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{tideData.lowTides[0]}</p>
            <p style={{fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0}}>{tideData.lowTides[1]}</p>
            <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>{t("lowTide")}</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
            <p style={{fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{tideData.highTides[0]}</p>
            <p style={{fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0}}>{tideData.highTides[1]}</p>
            <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>{t("highTide")}</p>
            </div>

          </div>
          <img src={WhiteWave} style={{ width: 64, height: 8,marginTop:20 }} alt="" />
          
        </div>
      </Drawer>
    </div>
  );
}

export default Home;
